import { createAsyncSlice } from 'store/createAsyncSlice';
import { postTaxCertificationsAsync } from 'API/taxCertifications/postTaxCertificationsAsync';

export const { slice: postTaxCertificationsSlice, asyncAction: postTaxCertificationsAsyncAction } = createAsyncSlice(
  'postTaxCertificationSlice',
  postTaxCertificationsAsync
);
